
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/managedfund",
      function () {
        return require("private-next-pages/managedfund.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/managedfund"])
      });
    }
  